import { WebsiteModule } from '@/interfaces/module.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface CreateWebsiteModuleResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const createWebsiteModule = (
  params: ApiQueryParams,
  data: WebsiteModule
) =>
  apiRequest<WebsiteModule, CreateWebsiteModuleResponse>({
    url: '/entities/create',
    scope: 'module',
    method: 'POST',
    params,
    data: { data },
  });

